<div [formGroup]="form">

    <div class="row">
        <div class="col-md-12">

            <div class="row">
                <!--Motivos del rechazo-->
                <div class="col-md-12">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedMotivosRechazo = !isCollapsedMotivosRechazo" [attr.aria-expanded]="!isCollapsedMotivosRechazo" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> Motivos del rechazo
                                <!--<i *ngIf="isCollapsedMotivosRechazo" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedMotivosRechazo" class="fa fa-caret-up float-right"></i>-->
                            </div>
                        </a>

                        <div class="card-body-rechazos-traces">

                            <p-table #tableSearch autoLayout="true" [value]="rechazoTracesNoCumplimiento?.MotivosList"
                                     [columns]="colsMotivos" sortField="Descripcion" sortOrder="1"
                                     styleClass="table table-responsive-sm table-striped table-sm table-0-marginbot"
                                     [ngClass]="displayGridHidden(rechazoTracesNoCumplimiento?.MotivosList)" dataKey="IdRowMotivo">

                                <ng-template pTemplate="header" let-columns>
                                    <tr>
                                        <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                            {{col.header}}
                                            <p-sortIcon *ngIf="(col.field!=='Link' && col.field!=='MotivoProductosEmbalajes')" [field]="col.field"></p-sortIcon>
                                        </th>
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">
                                    <tr>
                                        <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                            <span *ngIf="col.field!=='OrganismoNocivo' && col.field!=='MotivoProductosEmbalajes'">
                                                {{rowData[col.field]}}
                                            </span>

                                            <span *ngIf="col.field==='OrganismoNocivo'">
                                                    <td *ngIf="rowData['OrganismoNocivo']" class="td-cell" colspan="12">
                                                        <div class="taric-code" title="Código EPPO">{{rowData['OrganismoNocivo'].DescripcionOne}}</div>
                                                        <div class="description"> - {{rowData['OrganismoNocivo'].DescripcionTwo}}</div>
                                                    </td>
                                            </span>

                                            <div style="text-align: center;">
                                                <span *ngIf="col.field==='MotivoProductosEmbalajes'">
                                                    <a href="#" class="btn button-row-expand align-chevron" [pRowToggler]="rowData" [title]="expanded ? 'Ocultar productos y embalajes' : 'Mostrar productos y embalajes'" [ngClass]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
                                                    </a>
                                                </span>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="rowexpansion" let-rowData let-columns="columns">
                                    <tr>
                                        <td colspan="10">

                                            <div *ngIf="rowData['MotivoEmbalajesList'].length !== 0">
                                                <p (click)="rowData.viewDetailsMotivoEmbalajes = !rowData.viewDetailsMotivoEmbalajes" class="title-productos-embalajes">Embalajes <i [ngClass]="rowData.viewDetailsMotivoEmbalajes ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" class="chevron-productos-embalajes"></i></p>
                                            </div>

                                            <ng-container *ngTemplateOutlet="extensiontemplatemotivoembalajes; context: rowData"></ng-container>
                                            <ng-template #extensiontemplatemotivoembalajes>
                                                <tr *ngIf="rowData.viewDetailsMotivoEmbalajes" style="display: contents !important;">
                                                    <div *ngFor="let motivoEmbalaje of rowData['MotivoEmbalajesList']">
                                                        <td class="td-cell" colspan="12">
                                                            <div class="taric-code" title="Código TARIC">{{motivoEmbalaje.Taric}}</div>
                                                            <div class="description"> - {{motivoEmbalaje.DescripcionOne}}</div>
                                                        </td>
                                                    </div>
                                                </tr>
                                            </ng-template>

                                            <div *ngIf="rowData['MotivoProductosList'].length !== 0">
                                                <p (click)="rowData.viewDetailsMotivoProductos = !rowData.viewDetailsMotivoProductos" class="title-productos-embalajes">Productos <i [ngClass]="rowData.viewDetailsMotivoProductos ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" class="chevron-productos-embalajes"></i></p>
                                            </div>

                                            <ng-container *ngTemplateOutlet="extensiontemplatemotivoproductos; context: rowData"></ng-container>
                                            <ng-template #extensiontemplatemotivoproductos>
                                                <tr *ngIf="rowData.viewDetailsMotivoProductos" style="display: contents !important;">
                                                    <div *ngFor="let motivoProducto of rowData['MotivoProductosList']">
                                                        <td class="td-cell" colspan="12">
                                                            <div class="taric-code" title="Código TARIC">{{motivoProducto.Taric}}</div>
                                                            <div class="description"> - {{motivoProducto.DescripcionOne}}</div>
                                                        </td>
                                                    </div>
                                                </tr>
                                            </ng-template>
                                        </td>
                                    </tr>
                                </ng-template>

                            </p-table>

                            <div *ngIf="numeroMotivos === 0" class="empty-grid">
                                No hay motivos asociados al rechazo
                            </div>

                        </div>

                    </div>
                </div>
            </div>

            <div class="row">
                <!--Medidas adoptadas-->
                <div class="col-md-12">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedMedidasAdoptadas = !isCollapsedMedidasAdoptadas" [attr.aria-expanded]="!isCollapsedMedidasAdoptadas" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> Medidas adoptadas
                                <!--<i *ngIf="isCollapsedMedidasAdoptadas" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedMedidasAdoptadas" class="fa fa-caret-up float-right"></i>-->
                            </div>
                        </a>

                        <div class="card-body-rechazos-traces">

                            <p-table #tableSearch autoLayout="true" [value]="rechazoTracesNoCumplimiento?.MedidasList"
                                     [columns]="colsMedidas" sortField="Descripcion" sortOrder="1"
                                     styleClass="table table-responsive-sm table-striped table-sm table-0-marginbot"
                                     [ngClass]="displayGridHidden(rechazoTracesNoCumplimiento?.MedidasList)" dataKey="IdRowMedida">

                                <ng-template pTemplate="header" let-columns>
                                    <tr>
                                        <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                            {{col.header}}
                                            <p-sortIcon *ngIf="(col.field!=='Link' && col.field!=='MedidaProductosEmbalajes')" [field]="col.field"></p-sortIcon>
                                        </th>
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">
                                    <tr>
                                        <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                            <span *ngIf="(col.field!=='FechaInicioCuarentena' && col.field!=='FechaFinPrevistaCuarentena' && col.field!=='FechaFinCuarentena' && col.field!=='MedidaProductosEmbalajes')">
                                                {{rowData[col.field]}}
                                            </span>

                                            <span *ngIf="col.field==='FechaInicioCuarentena' || col.field==='FechaFinPrevistaCuarentena' || col.field==='FechaFinCuarentena'">{{rowData[col.field] | date:'dd/MM/yyyy'}}</span>

                                            <div style="text-align: center;">
                                                <span *ngIf="col.field==='MedidaProductosEmbalajes'">
                                                    <a href="#" class="btn button-row-expand align-chevron" [pRowToggler]="rowData" [title]="expanded ? 'Ocultar productos y embalajes' : 'Mostrar productos y embalajes'" [ngClass]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
                                                    </a>
                                                </span>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="rowexpansion" let-rowData let-columns="columns">
                                    <tr>
                                        <td colspan="10">

                                            <div *ngIf="rowData['MedidaEmbalajesList'].length !== 0">
                                                <p (click)="rowData.viewDetailsMedidaEmbalajes = !rowData.viewDetailsMedidaEmbalajes" class="title-productos-embalajes">Embalajes <i [ngClass]="rowData.viewDetailsMedidaEmbalajes ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" class="chevron-productos-embalajes"></i></p>
                                            </div>

                                            <ng-container *ngTemplateOutlet="extensiontemplatemedidaembalajes; context: rowData"></ng-container>
                                            <ng-template #extensiontemplatemedidaembalajes>
                                                <tr *ngIf="rowData.viewDetailsMedidaEmbalajes" style="display: contents !important;">
                                                    <div *ngFor="let medidaEmbalaje of rowData['MedidaEmbalajesList']">
                                                        <td class="td-cell" colspan="12">
                                                            <div class="taric-code" title="Código TARIC">{{medidaEmbalaje.Taric}}</div>
                                                            <div class="description"> - {{medidaEmbalaje.DescripcionOne}}</div>
                                                        </td>
                                                    </div>
                                                </tr>
                                            </ng-template>

                                            <div *ngIf="rowData['MedidaProductosList'].length !== 0">
                                                <p (click)="rowData.viewDetailsMedidaProductos = !rowData.viewDetailsMedidaProductos" class="title-productos-embalajes">Productos <i [ngClass]="rowData.viewDetailsMedidaProductos ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" class="chevron-productos-embalajes"></i></p>
                                            </div>

                                            <ng-container *ngTemplateOutlet="extensiontemplatemedidaproductos; context: rowData"></ng-container>
                                            <ng-template #extensiontemplatemedidaproductos>
                                                <tr *ngIf="rowData.viewDetailsMedidaProductos" style="display: contents !important;">
                                                    <div *ngFor="let medidaProducto of rowData['MedidaProductosList']">
                                                        <td class="td-cell" colspan="12">
                                                            <div class="taric-code" title="Código TARIC">{{medidaProducto.Taric}}</div>
                                                            <div class="description"> - {{medidaProducto.DescripcionOne}}</div>
                                                        </td>
                                                    </div>
                                                </tr>
                                            </ng-template>
                                        </td>
                                    </tr>
                                </ng-template>

                            </p-table>

                            <div *ngIf="numeroMedidas === 0" class="empty-grid">
                                No hay medidas asociadas al rechazo
                            </div>

                        </div>

                        <div class="card-body-rechazos-traces">
                            <div class="row">

                                <div class="form-group col-md-12">
                                    <label class="col-form-label" for="ComentarioMedidas" style="margin-left: 5px;">Comentario</label>
                                    <input formControlName="ComentarioMedidas" name="ComentarioMedidas" title="" class="form-control" id="ComentarioMedidas" type="text" value="" [ngClass]="displayFieldCss('ComentarioMedidas')" readonly style="margin-left: 5px; width: 99.4%;">
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="row">
                <!--Documentos relacionados-->
                <div class="col-md-12">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedDocumentosRelacionados = !isCollapsedDocumentosRelacionados" [attr.aria-expanded]="!isCollapsedDocumentosRelacionados" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> Documentos relacionados
                                <!--<i *ngIf="isCollapsedDocumentosRelacionados" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedDocumentosRelacionados" class="fa fa-caret-up float-right"></i>-->
                            </div>
                        </a>

                        <div class="card-body-rechazos-traces">

                            <p-table #tableSearch autoLayout="true" [value]="rechazoTracesNoCumplimiento?.Documentos"
                                     [columns]="colsDocumentos" sortField="Fecha" sortOrder="-1"
                                     styleClass="table table-responsive-sm table-striped table-sm table-0-marginbot"
                                     [ngClass]="displayGridHidden(rechazoTracesNoCumplimiento?.Documentos)">

                                <ng-template pTemplate="header" let-columns>
                                    <tr>
                                        <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                            {{col.header}}
                                            <p-sortIcon *ngIf="col.field!=='Link'" [field]="col.field"></p-sortIcon>
                                        </th>
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">
                                    <tr>
                                        <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                            <span *ngIf="(col.field!=='Link' && col.field!=='Fecha')">
                                                {{rowData[col.field]}}
                                            </span>

                                            <div *ngIf="col.field==='Link'" class="btn-group">
                                                <button  (click)="onDownload(rowData)" type="button" class="btn btn-sm btn-secondary" title="Descargar documento">
                                                    <span class="fa fa-download"></span>
                                                </button>
                                            </div>

                                            <span *ngIf="col.field==='Fecha'">
                                                {{rowData[col.field] | date:'dd/MM/yyyy'}}
                                            </span>

                                        </td>
                                    </tr>
                                </ng-template>

                            </p-table>

                            <div *ngIf="numeroDocumentos === 0" class="empty-grid">
                                No hay documentos asociados al rechazo
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="row">
                <!--Lugar de inspección-->
                <div class="col-md-6">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedLugarInspeccion = !isCollapsedLugarInspeccion" [attr.aria-expanded]="!isCollapsedLugarInspeccion" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> Lugar de inspección
                                <i *ngIf="isCollapsedLugarInspeccion" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedLugarInspeccion" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>

                        <div class="card-body-detalle">
                            <div class="collapse group-filtros" id="collapsedLugarInspeccion" [ngbCollapse]="isCollapsedLugarInspeccion">
                                <div class="row">
                                    <div class="form-group col-md-6">
                                        <label class="col-form-label" for="TipoLugarInspeccion">Tipo de lugar de inspección</label>
                                        <input formControlName="TipoLugarInspeccion" name="TipoLugarInspeccion" title="" class="form-control" id="TipoLugarInspeccion" type="text" value="" [ngClass]="displayFieldCss('TipoLugarInspeccion')" readonly>
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label class="col-form-label" for="NombreInspector">Nombre</label>
                                        <input formControlName="NombreInspector" name="NombreInspector" title="" class="form-control" id="NombreInspector" type="text" value="" [ngClass]="displayFieldCss('NombreInspector')" readonly>
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label class="col-form-label" for="PaisInspeccion">País</label>
                                        <input formControlName="PaisInspeccion" name="PaisInspeccion" title="" class="form-control" id="PaisInspeccion" type="text" value="" [ngClass]="displayFieldCss('PaisInspeccion')" readonly>
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label class="col-form-label" for="CodigoISOInspeccion">Código ISO</label>
                                        <input formControlName="CodigoISOInspeccion" name="CodigoISOInspeccion" title="" class="form-control" id="CodigoISOInspeccion" type="text" value="" [ngClass]="displayFieldCss('CodigoISOInspeccion')" readonly>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <!--Tipo de inspección-->
                <div class="col-md-6">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedTipoInspeccion = !isCollapsedTipoInspeccion" [attr.aria-expanded]="!isCollapsedTipoInspeccion" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> Tipo de inspección
                                <i *ngIf="isCollapsedTipoInspeccion" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedTipoInspeccion" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>

                        <div class="card-body-detalle">
                            <div class="collapse group-filtros" id="collapsedTipoInspeccion" [ngbCollapse]="isCollapsedTipoInspeccion">
                                <div class="row">
                                    <div class="form-group col-md-12">
                                        <label class="col-form-label" for="TipoInspSupervisionPuestoInsp">
                                            Seguimiento de la entrada al puesto de inspección
                                        </label>
                                        <div *ngIf="rechazoTracesNoCumplimiento?.TipoInspSupervisionPuestoInsp === 'YES'" class="icon-satisfactory-rechazos-traces">
                                            <img src="../../../../../../assets/images/Rechazos_TRACES/Satisfactorio.png" />
                                        </div>
                                        <div *ngIf="rechazoTracesNoCumplimiento?.TipoInspSupervisionPuestoInsp === 'NO'" class="icon-satisfactory-rechazos-traces">
                                            <img src="../../../../../../assets/images/Rechazos_TRACES/NO_Satisfactorio.png" />
                                        </div>
                                    </div>

                                    <div class="form-group col-md-12">
                                        <label class="col-form-label" for="TipoInspControlSeguimientoNoSintomas">
                                            Control de seguimiento realizado sobre el envío sin síntomas ni sospechas y sin retener el envío
                                        </label>
                                        <div *ngIf="rechazoTracesNoCumplimiento?.TipoInspControlSeguimientoNoSintomas === 'YES'" class="icon-satisfactory-rechazos-traces">
                                            <img src="../../../../../../assets/images/Rechazos_TRACES/Satisfactorio.png" />
                                        </div>
                                        <div *ngIf="rechazoTracesNoCumplimiento?.TipoInspControlSeguimientoNoSintomas === 'NO'" class="icon-satisfactory-rechazos-traces">
                                            <img src="../../../../../../assets/images/Rechazos_TRACES/NO_Satisfactorio.png" />
                                        </div>
                                    </div>

                                    <div class="form-group col-md-12">
                                        <label class="col-form-label" for="TipoInspControlSeguimientoSiSintomas">
                                            Control de seguimiento realizado de envíos con síntomas o sospecha
                                        </label>
                                        <div *ngIf="rechazoTracesNoCumplimiento?.TipoInspControlSeguimientoSiSintomas === 'YES'" class="icon-satisfactory-rechazos-traces">
                                            <img src="../../../../../../assets/images/Rechazos_TRACES/Satisfactorio.png" />
                                        </div>
                                        <div *ngIf="rechazoTracesNoCumplimiento?.TipoInspControlSeguimientoSiSintomas === 'NO'" class="icon-satisfactory-rechazos-traces">
                                            <img src="../../../../../../assets/images/Rechazos_TRACES/NO_Satisfactorio.png" />
                                        </div>
                                    </div>

                                    <div class="form-group col-md-3">
                                        <label class="col-form-label" for="FechaTipoInspeccion">Fecha de la inspección</label>
                                        <input formControlName="FechaTipoInspeccion" name="FechaTipoInspeccion" title="" class="form-control" id="FechaTipoInspeccion" type="text" value="" [ngClass]="displayFieldCss('FechaTipoInspeccion')" readonly>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </div>
    </div>

</div>
